import React, { useState } from 'react';
import { Modal, Form, Input, DatePicker, message } from 'antd';
import apis from '@/apis/room/index';
import './index.less';

const layout = {
  labelCol: {
    span: 4,
  },
  wrapperCol: {
    span: 16,
  },
};

function AddPage(props) {
  const { visible, setVisible, towerId, refresh } = props;
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const handleOk = () => {
    form.submit();
  };

  const handleCancel = () => {
    setVisible(false);
    form.resetFields();
  };

  const onFormFinish = (values) => {
    if (loading) return;
    const { name, startTime } = values;
    const query = {
      towerId: towerId,
      name: name,
      startTime: new Date(startTime).getTime(),
      type: 2,
    };
    setLoading(true);
    apis
      .AddTowerPage(query)
      .then((res) => {
        const { ret, msg } = res;
        if (ret === '0') {
          message.success('新建成功');
          setVisible(false);
          refresh();
        } else {
          message.error(msg);
        }
        form.resetFields();
        setLoading(false);
      })
      .catch((e) => {
        console.log(e);
      });
  };

  return (
    <Modal
      title={
        <span className="venueDetail__addPage__modal__title">
          新建页面
          <span className="venueDetail__addPage__modal__sub-title">同步完成会场收品活动创建</span>
        </span>
      }
      visible={visible}
      onCancel={handleCancel}
      onOk={handleOk}
    >
      <Form {...layout} form={form} onFinish={onFormFinish}>
        <Form.Item
          label="页面名称: "
          name="name"
          rules={[
            {
              required: true,
              message: '页面名称不能为空',
            },
          ]}
        >
          <Input placeholder="请输入页面名称" />
        </Form.Item>
        <Form.Item
          label="生效时间: "
          name="startTime"
          rules={[
            {
              required: true,
              message: '生效时间不能为空',
            },
          ]}
        >
          <DatePicker />
        </Form.Item>
      </Form>
    </Modal>
  );
}

export default AddPage;
